module.exports = __webpack_public_path__ + "img/hdzx_3.d36cc13a.png";